import React from 'react';
import HttpsRedirect from 'react-https-redirect';
import { BrowserRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import './App.scss';
import { getTheme } from './helpers/Theme';
import { Provider } from 'react-redux';
import { store } from './reactRedux/store';
import Router from './helpers/Router';
import { getMessaging, onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import RTL from './helpers/RTL';
import RTL5 from './helpers/Mui5RTL';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Container } from '@material-ui/core';
import * as ReactGA from 'react-ga';
import { LanguageProvider, useTranslation } from './i18n/LanguageProvider';

export const queryClient = new QueryClient();

const AppContent = () => {
  const { t, language, direction } = useTranslation();

  return (
    <RTL>
      <RTL5>
        <ThemeProvider theme={getTheme(direction)}>
          <CssBaseline />
          <Provider store={store}>
            <BrowserRouter>
              <Helmet
                defaultTitle={t('app.name')}
                titleTemplate={`${t('app.name')} | %s`}
              />
              <Container maxWidth="lg" disableGutters>
                {/* remount on language change so every page re-reads its texts */}
                <div className="App" key={language}>
                  <Router />
                </div>
              </Container>
            </BrowserRouter>
          </Provider>
        </ThemeProvider>
      </RTL5>
    </RTL>
  );
};

function App() {
  onMessage(getMessaging(), (payload) => {
    toast.info(payload.notification.body);
  });

  ReactGA.initialize('432440037');
  return (
    <HttpsRedirect>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </QueryClientProvider>
    </HttpsRedirect>
  );
}

export default App;
